import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GoogleMapLinkPipe } from 'src/business/chrome/pipe/google-map-link.pipe';
import { MenuConfiguration } from 'src/business/models/main-configuration.model';
import { MediaModule } from 'src/layout/media/media.module';
import { StorageUtil } from 'src/utils/storage.util';

@Component({
    selector: 'app-footer-contact',
    templateUrl: './footer-contact.component.html',
    styleUrls: ['./footer-contact.component.scss'],
    standalone: true,
    imports:[CommonModule, TranslateModule, MediaModule, GoogleMapLinkPipe],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterContactComponent {
    menu: Partial<MenuConfiguration> = StorageUtil.get<MenuConfiguration>('menu');

}
